// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Moment from 'vue-moment'
import App from './App'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import FlashMessage from '@smartweb/vue-flash-message'
import VueGoodTablePlugin from 'vue-good-table'

// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(Moment)
Vue.use(FlashMessage, {strategy: 'multiple'})
Vue.use(VueGoodTablePlugin)
Vue.use(VueAxios, Axios)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js